import Api from "../../../api";
import {
  API_CREATE_USER,
  API_GET_USERS,
  API_UPDATE_USER,
  API_DELETE_UPDATE_USER,
  API_CONFIRM_DELETE_USER,
} from "../../../api/constants";

export const ACTION_GET_USERS = "ACTION_GET_USERS";

export function actionAddUser(data) {
  return (dispatch, getState) =>
    Api.post(API_CREATE_USER, data)
      .then((res) => {
        const data = res;
        console.log(data);
        return data;
      })
      .catch((reason) => {
        return reason;
      });
}

export function actionUpdateUser(data, userId) {
  return (dispatch, getState) =>
    Api.post(`${API_UPDATE_USER}/${userId}`, data)
      .then((res) => {
        const data = res;
        console.log(data);
        return data;
      })
      .catch((reason) => {
        return reason;
      });
}

export const actionGetUsers = (adminId) => async (dispatch) => {
  const response = await Api.get(API_GET_USERS);
  dispatch({ type: ACTION_GET_USERS, payload: response.data });
  return response;
};

export function actionDeleteUser(userId) {
  return (dispatch, getState) =>
    Api.delete(`${API_DELETE_UPDATE_USER}/${userId}`)
      .then((res) => {
        const data = res;
        console.log(data);
        return data;
      })
      .catch((reason) => {
        /** Handle Error */
        var data = {
          message: "",
        };
      });
}

export function actionConfirmDeleteUser(userId) {
  return (dispatch, getState) =>
    Api.delete(`${API_CONFIRM_DELETE_USER}/${userId}`)
      .then((res) => {
        const data = res;
        console.log(data);
        return data;
      })
      .catch((reason) => {
        /** Handle Error */
        var data = {
          message: "",
        };
      });
}
